export enum ChatInfoEnum {
  ATTRIBUTES = 'attributes',
  NOTES = 'notes',
  LEADSALES_AI = 'leadsales_ai',
  PROGRAMMED_MESSAGES = 'programmed_messages',
  STARED_MESSAGES = 'stared_messages',
}
